// Deploy field report 2026-07-13 — task-UUID hint on RUNTIME_NOT_FOUND.
//
// `plug --verbose` prints `GET /api/v2/tasks/<uuid>` while polling the
// queued deploy; users then run `grid status <task-uuid>` or
// `grid info <task-uuid>` and get a bare RUNTIME_NOT_FOUND. When the
// argument the user typed looks like a UUID, append a hint that names
// the likely mistake and the right next step. Mirrors the spirit of
// logs.ts's backlog-268 graceful RUNTIME_NOT_FOUND handling, kept small:
// one message rewrite, no extra round-trips.

import { V2ApiError } from '../api/v2-errors.js';
import { isEntityUuid } from './entity-ref.js';

export const TASK_UUID_HINT =
  'A UUID from plug --verbose is usually the deploy task id, not the entity. ' +
  'Use the entity name or slug (see grid status --help), or check the deploy ' +
  'with grid versions <name>.';

/**
 * When `err` is a RUNTIME_NOT_FOUND V2ApiError and the user-supplied
 * argument is UUID-shaped, return a copy of the error with the hint
 * appended to its message. Every other error passes through unchanged.
 */
export function withTaskUuidHint(err: unknown, arg: string): unknown {
  if (
    err instanceof V2ApiError &&
    err.code === 'RUNTIME_NOT_FOUND' &&
    isEntityUuid(arg.trim())
  ) {
    return new V2ApiError(
      err.status,
      err.code,
      `${err.message}\n  ${TASK_UUID_HINT}`,
      err.details,
      err.requestId,
      err.text,
    );
  }
  return err;
}
